<rip-carousel #chartCarousel [slides]="slides" [prevLabel]="prevLabel" [nextLabel]="nextLabel"
              (slideChanged)="slideChange($event)" *ngIf="slides" [ngClass]="{ 'mobile-class': deviceIsMobile }">
</rip-carousel>
